import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

import {DATE_TIME_FORMAT} from '../util/constants'
import {formatDate} from "../util/date/dateFunctions"

export default class MyBookingsList {
  static buildRequest(bookingObj) {
    let returnValue = null;
    try {
      let body = {
        "orderId": bookingObj.orderId,
        "pnr": bookingObj.pnr,
        "firstName": bookingObj.firstName,
        "lastName": bookingObj.lastName,
        "departure": bookingObj.departure,
        "arrival": bookingObj.arrival,
        "journeyType": bookingObj.journeyType,
        "travelDateFrom": bookingObj.travelDateFrom ? formatDate(bookingObj.travelDateFrom,DATE_TIME_FORMAT.API_DATE_FORMAT) : null,
        "travelDateTo": bookingObj.travelDateTo ? formatDate(bookingObj.travelDateTo,DATE_TIME_FORMAT.API_DATE_FORMAT) : null,
        "airline": bookingObj.airline,
        "b2bid": bookingObj.b2bid,
        "userId":bookingObj.userId,
        "ticketNumber":bookingObj.ticketNumber,
        "bookingDateFrom": bookingObj.bookingDateFrom? formatDate(bookingObj.bookingDateFrom,DATE_TIME_FORMAT.API_DATE_FORMAT) : null,
        "bookingDateTo": bookingObj.bookingDateTo? formatDate(bookingObj.bookingDateTo,DATE_TIME_FORMAT.API_DATE_FORMAT) : null,
       // "bookingDateFrom": null,
       // "bookingDateTo": null,
       "b2bGroupId":bookingObj.b2bGroupId,
       
    }

      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_GET_MY_BOOKINGS,
        "error in building body for MyBookingsList",
        err.toString(),
        "buildRequest",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {
      returnValue = await HttpPost.makeHttpPostRequest(
        SERVICE_URL.GET_MY_BOOKINGS,
        pReqOptions
      );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_GET_MY_BOOKINGS,
        "error in getting Response from  MyBookingsList",
        err.toString(),
        "getResponse",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }
}
